export const TOOLTIP_TEXT = (t, x, y) => ({
  total_amount_returned: t('tooltip.total_amount_returned'),
  total_interest_earned: t('tooltip.total_interest_earned'),
  projected_annual_return: t('tooltip.projected_annual_return'),
  extra_for_every_5: t('tooltip.extra_for_every_5', { x, y}),
  increased_rate: t('tooltip.increased_rate'),
  total_contributions: t('tooltip.total_contributions'),
});
